import React from 'react';
import CustomButton from '../CustomButton/CustomButton';
import Icon from '../../../utils/Icon';
import {Else, If, Then} from 'react-if';
import {formatPrice, isZero} from '../../../utils/helper';
import classnames from 'classnames';
import styles from './Card.module.scss';
import {isNotBlankOrNullString} from "../../../utils/stringUtils";
import greenPlus from "../../../assets/images/icons/greenPlus.png";
import mapping from "../../../config/mapping";

const Card = ({
                  rateplan,
                  noMarginTop = false,
                  onLearnMore = () => {
                  },
                  tabText = '',
                  freeText = '',
                  buttonText = '',
                  priceLabelText = '',
                  footerText = '',
                  subsidyAmount = '',
                  priceDiscountLabelText = '',
              }) => {
    if (rateplan == null) return <></>;

    const {
        subName,
        displayName,
        mainName,
        characteristics,
        extraCharacteristics,
        initialPrice,
        finalPrice,
        imageUrl,
        associatedProducts,
        textOnProductDetails
    } = rateplan;
    const characteristicsMap = mapping.characteristicsMap;

    const handleLearnMoreClick = () => {
        onLearnMore(rateplan?.productUrl);
    };

    const RatePlanTitle = () => (
        <div className={classnames(styles.rate_plan_title_container)}>
            {isNotBlankOrNullString(subName) && isNotBlankOrNullString(displayName)
                ?
                <>
                    <div className={styles.rate_plan_title}>{subName}</div>
                    <div className={styles.rate_plan_sub_title}>{mainName}</div>
                </>
                :
                <div className={styles.rate_plan_sub_title}>{displayName}</div>
            }
        </div>
    );

    const RatePlanPrice = ({finalPrice, priceLabelText}) => (
        <div className={classnames(styles.main_price_container)}>
            <div className={styles.price_container}>
                <div className={styles.price_label}>{priceLabelText}</div>
                {initialPrice && initialPrice !== finalPrice &&
                    <div className={styles.initial_price}>{formatPrice(initialPrice)}</div>
                }

                <div className={styles.final_price}  style={(isZero(initialPrice) || initialPrice !== finalPrice) ? { color: '#E20074' } : {}}>
                    <If condition={isZero(finalPrice)}>
                        <Then>{freeText}</Then>
                        <Else>{formatPrice(finalPrice)}</Else>
                    </If>
                </div>
            </div>
        </div>
    );

    const RatePlanCharacteristics = () => (
        <ul className={classnames(styles.characteristics_container, 'list-group mx-auto d-flex')}>
            {characteristics?.map((char, index) => (
                <div
                    className={classnames(styles.characteristic, Object.keys(characteristicsMap).includes(char?.imgType)
                        ? 'list-group-item d-flex' : '', textOnProductDetails ? styles.characteristic_label_container : '')}
                    key={index}>
                    {characteristicsMap[char?.imgType] &&
                        <div className="d-inline-flex align-items-center justify-content-center text-white rounded-circle m-0 me-2">
                            <Icon name={characteristicsMap[char?.imgType]} className={styles.characteristic_prefix_img}
                                  alt="device-lan"/>
                        </div>
                    }

                    {!(char.name === 'Contract Duration') &&
                        <>
                            <div className={styles.characteristic_text_container}>
                                {textOnProductDetails && index === 1 &&
                                    <div className={styles.characteristic_label}>
                                        <span>{textOnProductDetails}</span>
                                    </div>}
                                <div className={styles.characteristic_value}>
                                    {char?.prefix} {' '} <span
                                    style={{fontWeight: '600'}}  >{char?.value} {char?.unitOfMeasure} <span dangerouslySetInnerHTML={{ __html: char?.name }}></span> </span>
                                </div>
                            </div>
                        </>
                    }
                </div>
            ))}
        </ul>
    );

    return (
        <div className={classnames(styles.plan_container, 'card border-0 h-100')}>
            {/* Conditional Top Tag */}
            {tabText &&
                <div className={styles.top_tag_container}>
                    <span className={styles.top_tag_text} dangerouslySetInnerHTML={{ __html: tabText }}/>
                </div>
            }
            <div className="card-body p-0 d-flex gap-1 flex-column justify-content-between">
                {/* Top Section */}
                <div className={classnames(styles.card_top_section)}>
                    <div className="d-flex justify-content-center mt-20" style={{height: '60px', width: '100%'}}>
                        {associatedProducts && associatedProducts.length > 1 ? (
                            <>
                                <div className={classnames(styles.associatedProducts)}>
                                    <img
                                        className={classnames("product-img", styles.associatedProductsImage)}
                                        src={window.location.origin+associatedProducts[0]?.mediumImageUrl}
                                        alt="Rateplan Image"
                                    />
                                    <div className="img-label">{associatedProducts[0]?.typeDesc}</div>
                                </div>

                                <div className={classnames(styles.greenIcon)}>
                                    <img
                                        src={greenPlus}
                                        alt="Plus Icon"
                                        className={classnames(styles.greenIconImg)}
                                    />
                                </div>

                                <div className={classnames(styles.associatedProducts)}>
                                    <img
                                        className={classnames("product-img", styles.associatedProductsImage)}
                                        src={window.location.origin+associatedProducts[1]?.mediumImageUrl}
                                        alt="Rateplan Image"
                                    />
                                    <div className="img-label">{associatedProducts[1]?.typeDesc}</div>

                                </div>
                            </>
                        ) : (
                            <img
                                className="product-img"
                                src={window.location.origin+imageUrl}
                                alt="Rateplan Image"
                            />
                        )}
                    </div>
                    <RatePlanTitle/>
                    <RatePlanCharacteristics characteristics={characteristics}/>
                    <div className={styles.extraCharacteristics}
                         dangerouslySetInnerHTML={{__html: extraCharacteristics}}></div>

                </div>

                {/* Bottom Section */}
                <div className={classnames(styles.card_bottom_section)}>
                    {finalPrice
                        ? <>
                            <RatePlanPrice finalPrice={finalPrice} initialPrice={initialPrice}
                                           priceLabelText={priceLabelText}/>
                            <CustomButton className={classnames(styles.item_button)}  onClick={() => window.location.href = `${window.location.origin}${rateplan?.productUrl}`}>
                                {buttonText}
                            </CustomButton>
                        </>
                        : <div className={styles.footerText}>{footerText}</div>
                    }
                </div>
            </div>

        </div>
    );
};

export default Card;
